const expandTogglers = document.querySelectorAll('.expand-toggler')
const buttonText = {
  more: {
    expanded: 'Less',
    collapsed: 'More',
  },
  show: {
    expanded: 'Hide',
    collapsed: 'Show',
  },
  expand: {
    expanded: 'Collapse',
    collapsed: 'Expand',
  },
}

expandTogglers.forEach((elem) => {
  const expander = elem.parentElement.parentElement.querySelector('.expander')
  const text = buttonText[elem.innerHTML.trim().toLowerCase()]
  elem.addEventListener('click', (e) => {
    if (expander.clientHeight) {
      expander.style.height = 0
    } else {
      const wrapper = expander.querySelector('.measure-wrapper')
      expander.style.height = wrapper.clientHeight + 'px'
    }

    if (elem.innerHTML === text.expanded) {
      elem.innerHTML = text.collapsed
    } else {
      elem.innerHTML = text.expanded
    }
  })
})
